export default __webpack_public_path__ + "static/media/not_found.3b51f6c3.png";